import { Role } from '../../types'
import { DistributionItem } from './types'

export const canViewAgentMetrics = (role: Role) => role === Role.agente
export const agentMetricsRouteForRole = (role: Role) =>
  canViewAgentMetrics(role) ? { name: 'Métricas', route: '/agent-metrics' } : null
export const AGENT_METRICS_BLOCKED_ROLES = Object.values(Role).filter(role => role !== Role.agente)
export const bogotaPeriod = () =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit'
  })
    .format(new Date())
    .slice(0, 7)

const COLORS = [
  '#F56600',
  '#1565C0',
  '#2E7D32',
  '#8E24AA',
  '#00838F',
  '#C62828',
  '#6D4C41',
  '#3949AB',
  '#558B2F',
  '#AD1457',
  '#455A64',
  '#EF6C00'
]
const EFFECTIVENESS_COLORS: Record<string, string> = {
  'Con completo en oficina': '#2E7D32',
  'Sin completo en oficina': '#455A64',
  Devueltos: '#EF6C00',
  Negados: '#C62828'
}
export const colorForLabel = (label: string) => {
  if (EFFECTIVENESS_COLORS[label]) return EFFECTIVENESS_COLORS[label]
  const hash = [...label].reduce((value, character) => (value * 31 + character.charCodeAt(0)) >>> 0, 7)
  return COLORS[hash % COLORS.length]
}
export const percentage = (count: number, data: DistributionItem[]) => {
  const total = data.reduce((sum, item) => sum + item.count, 0)
  return total ? Math.round((count / total) * 1000) / 10 : 0
}
